import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-vue-arrow-down",
  "use": "foquz-icon-vue-arrow-down-usage",
  "viewBox": "0 0 12 7",
  "content": "<symbol preserveAspectRatio=\"none\" overflow=\"visible\" viewBox=\"0 0 12 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-vue-arrow-down\"><path d=\"M1 1l5 5 5-5\" stroke=\"var(--stroke-0, #667799)\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol